import React, { useState } from "react";

import styles from "./SearchImage.module.css";

const SearchImage = function (props) {
  const [query, setQuery] = useState("");

  const onChangeHandler = function (e) {
    e.preventDefault();
    setQuery(e.target.value);
  };

  const onKeypressHandler = function (e) {
    if (e.key !== "Enter") {
      return;
    }

    props.onSearchSubmit(e.target.value);
    setQuery("");
  };

  return (
    <input
      className={`${styles["search"]} ${props.className}`}
      type="text"
      placeholder="Search or paste image url"
      value={query}
      onChange={onChangeHandler}
      onKeyPress={onKeypressHandler}
    ></input>
  );
};

export default SearchImage;
